import React, { PureComponent, Fragment } from "react";
import { I18n } from 'aws-amplify';
import { Row, Col, Tag } from 'antd';

import { CardBorder } from "../../components/Cards";
import Carousel from "../../components/Carousel";

import CarouselThumbs from "../../components/CarouselThumbs";
import ListLinks from "../../components/ListLinks";
import noPhoto from '../../../image/no-photo2.png';
import ReactPlayer from 'react-player';


import NotRegistered from "../../components/NotRegistered";

import styled from "styled-components";


const Box = styled.div`

.noMargin {
    div {
        margin-bottom: 0 !important;
    }
}

.TitleView {
    margin-bottom: 40px;
    h3 {
        margin-bottom: 5px;
    }
}

.colM {
    margin-bottom: 20px;
}

.ant-row-flex {
    margin-bottom: 20px;
}
p {
    font-size: 13px;
    line-height: 16px;
}

h4 {
    font-size: 14px;
    font-weight: bold;
    border-bottom: solid 1px #ccc;
    margin-bottom: 15px;
}

h3 {
    margin: 10px 0 20px;
    font-weight: bold;
}

.Sizing {
    width: 100%;
    max-width: 800px;
    margin: 50px auto;
}
    .ItemImg {
        margin: 0 2px;
        overflow: hidden;
        display: block;
        padding: 2px;
        max-width: 122px;

        img {
            width: calc(100% - 4px);
            display: block;
        }
    }
`

class ItemCase extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            play: true
        };
    }
    render() {
        const {
            brand = "",
            category,
            challenge,
            partnerId,
            photos,
            product,
            links,
            result,
            title,
            solution,
            specialism,
            type,
            videos,
            year,
        } = this.props.case;

        const specialismValues = specialism && specialism.map((item) => {

            const specialism = this.props.specialismsBP && this.props.specialismsBP.find((s) => s.code == item) || {};

            return specialism;

        });

        if (this.props.isPresentation) {
            return (
                <Box>
                    <Row className="TitleView">
                        <Col className="" sm={24}>
                            <h3>{title} | {year}</h3>
                            {type == 1 &&
                                <div>
                                    {specialismValues && specialismValues.map((i, index) => {
                                        return <Tag key={index} color="#000">{i.label}</Tag>
                                    })}
                                </div>
                            }
                        </Col>
                    </Row>
                    <Row className="">
                        <Col className="" sm={24}>

                            <CarouselThumbs
                                dots={true}
                                dotsClass="slick-dots slick-thumb"
                                infinite={true}
                                speed={500}
                                slidesToShow={1}
                                slidesToScroll={1}
                                afterChange={() => {
                                    this.setState({
                                        play: false
                                    });

                                    setTimeout(() => {
                                        this.setState({
                                            play: true
                                        });
                                    }, 100);
                                }}
                                
                            >
                                {videos.length <= 0 && photos.length <= 0 &&
                                    <div className="ItemImgFull">
                                        <img src={noPhoto} />
                                    </div>
                                }

                                {
                                    videos && videos.length > 0 && videos.map((item, index) => {
                                        return (
                                            <div key={index} className="ItemImgFull">
                                                <ReactPlayer
                                                    // playing={this.state.play}
                                                    url={this.state.play && item}
                                                    style={{ margin: '0 auto' }}
                                                    onPause={() => this.setState({ play: false })}
                                                    controls={true}
                                                />
                                            </div>
                                        )
                                    })
                                }
                                {
                                    photos.map((item, index) => {
                                        return (
                                            <div key={index} className="ItemImgFull">
                                                <img src={item} />
                                            </div>
                                        )
                                    })
                                }

                            </CarouselThumbs>
                        </Col>
                    </Row>
                    <Row className="">
                        <Col className="noMargin" sm={24}>
                            <CardBorder

                            >
                                <h4>{I18n.get("Marca")}</h4>
                                <p>{brand && brand}</p>
                            </CardBorder>
                        </Col>
                        <Col className="noMargin" sm={24}>
                            <CardBorder

                            >
                                <h4>{I18n.get("Produto")}</h4>
                                <p>{product}</p>
                            </CardBorder>
                        </Col>
                        <Col className="noMargin" sm={24}>
                            <CardBorder

                            >
                                <h4>{I18n.get("Categoria")}</h4>
                                <p>{this.props.category}</p>
                            </CardBorder>
                        </Col>

                        <Col className="noMargin" sm={24}>
                            <CardBorder

                            >
                                <h4>{I18n.get("Desafio")}</h4>
                                <p>{challenge}</p>
                            </CardBorder>
                        </Col>
                        <Col className="noMargin" sm={24}>
                            <CardBorder

                            >
                                <h4>{I18n.get("Solução")}</h4>
                                <p>{solution}</p>
                            </CardBorder>
                        </Col>
                        <Col className="noMargin" sm={24}>
                            <CardBorder

                            >
                                <h4>{I18n.get("Resultado")}</h4>
                                <p>{result}</p>
                            </CardBorder>
                        </Col>

                        {/* <Col className="noMargin" sm={24}>
                            <CardBorder
                                Bcolor="#f2f2f2"
                            >
                                <h4>Links</h4>

                                {links && links.length == 0 &&
                                    <NotRegistered
                                        text="Nenhum vídeo foi cadastrado!"
                                    />
                                }
                                {links && links.length > 0 &&
                                    <ListLinks data={links} icon="link" />
                                }
                            </CardBorder>
                        </Col> */}
                    </Row>
                </Box>
            );
        } else {



            return (
                <Box>
                    <Row className="" type="flex">
                        <Col className="" sm={8}>
                            <h3>{title}</h3>
                        </Col>
                    </Row>
                    <Row className="" type="flex">
                        <Col className="colM" sm={type == 2 ? 12 : 8}>
                            <CardBorder
                                Bcolor="#f2f2f2"
                            >
                                <h4>{I18n.get("Marca")}</h4>
                                <p>{brand && brand}</p>
                            </CardBorder>
                        </Col>
                        <Col className="colM" sm={type == 2 ? 12 : 8}>
                            <CardBorder
                                Bcolor="#f2f2f2"
                            >
                                <h4>{I18n.get("Produto")}</h4>
                                <p>{product}</p>
                            </CardBorder>
                        </Col>
                        <Col className="colM" sm={type == 2 ? 12 : 8}>
                            <CardBorder
                                Bcolor="#f2f2f2"
                            >
                                <h4>{I18n.get("Categoria")}</h4>
                                <p>{this.props.category}</p>
                            </CardBorder>
                        </Col>

                        <Col className="colM" sm={type == 2 ? 12 : 6}>
                            <CardBorder
                                Bcolor="#f2f2f2"
                            >
                                <h4>{I18n.get("Ano")}</h4>
                                <p>{year}</p>
                            </CardBorder>
                        </Col>
                        {type == 1 &&
                            <Col className="colM" sm={18}>
                                <CardBorder
                                    Bcolor="#f2f2f2"
                                >
                                    <h4>{I18n.get("Especialidades")}</h4>
                                    {specialismValues && specialismValues.map((i, index) => {
                                        return <Tag key={index} color="#000">{i.label}</Tag>
                                    })}
                                </CardBorder>
                            </Col>
                        }

                        <Col className="colM" sm={8}>
                            <CardBorder
                                Bcolor="#f2f2f2"
                            >
                                <h4>{I18n.get("Desafio")}</h4>
                                <p>{challenge}</p>
                            </CardBorder>
                        </Col>
                        <Col className="colM" sm={8}>
                            <CardBorder
                                Bcolor="#f2f2f2"
                            >
                                <h4>{I18n.get("Solução")}</h4>
                                <p>{solution}</p>
                            </CardBorder>
                        </Col>
                        <Col className="colM" sm={8}>
                            <CardBorder
                                Bcolor="#f2f2f2"
                            >
                                <h4>{I18n.get("Resultado")}</h4>
                                <p>{result}</p>
                            </CardBorder>
                        </Col>

                        <Col className="colM" sm={16}>
                            <CardBorder
                                Bcolor="#f2f2f2"
                            >
                                <h4>{I18n.get("Fotos")}</h4>
                                {photos.length == 0 &&
                                    <NotRegistered
                                        text="Nenhuma foto foi cadastrada!"
                                    />
                                }
                                {photos.length > 0 &&
                                    <div className="Sizing">
                                        <Carousel
                                            dots={false}
                                            infinite={false}
                                            slidesToShow={photos.length == 1 ? 1 : 3}
                                            slidesToScroll={1}
                                            variableWidth={false}
                                        >
                                            {photos.map((item, index) => {
                                                return (
                                                    <div key={index} className="ItemImg">
                                                        <img src={item} width={photos.length == 1 ? "122px" : "90%"} />
                                                    </div>
                                                )
                                            })}

                                        </Carousel>
                                    </div>
                                }
                            </CardBorder>
                        </Col>
                        {/* <Col className="colM" sm={8}>
                            <CardBorder
                                Bcolor="#f2f2f2"
                            >
                                <h4>Links</h4>

                                {links && links.length == 0 &&
                                    <NotRegistered
                                        text="Nenhum link foi cadastrado!"
                                    />
                                }
                                {links && links.length > 0 &&
                                    <ListLinks data={links} icon="link" />
                                }
                            </CardBorder>
                        </Col> */}


                        <Col className="colM" sm={8}>
                            <CardBorder

                            >
                                <h4>{I18n.get("Vídeos")}</h4>

                                {videos.length == 0 &&
                                    <NotRegistered
                                        text="Nenhum vídeo foi cadastrado!"
                                    />
                                }
                                {videos.length > 0 &&
                                    <ListLinks data={videos} icon="youtube" />
                                }
                            </CardBorder>
                        </Col>
                    </Row>


                </Box>
            );
        }
    }
}

export default ItemCase;
